import { ImageIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel } from 'features/kestrelViewer'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React from 'react'

interface PhotoReelButtonProps {
  onToggle: () => void
  isOpen: boolean
}

export const PhotoReelButton: React.FC<PhotoReelButtonProps> = ({
  onToggle,
  isOpen,
}) => {
  const { trackButtonClicked } = useGeckoAnalytics()
  const { kestrelModel } = useKestrel()

  return (
    <TooltipWrapper side={'right'} offset={5} label={'Photo Reel'}>
      <ViewToggle
        onClick={(selected, setSelected) => {
          setSelected(!isOpen)
          onToggle()
          trackButtonClicked({
            button_name: 'kestrel_photo_reel',
            kestrel_model_id: kestrelModel?.data.kestrel_model_id,
          })
        }}>
        <ImageIcon width={22} height={22} />
      </ViewToggle>
    </TooltipWrapper>
  )
}
